/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-incorrect': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<path pid="0" d="M1.645 1.212a.497.497 0 0 1 .633-.057l.068.057L5.5 4.365l3.154-3.153.07-.057a.496.496 0 0 1 .631.758L6.201 5.066l3.154 3.155a.496.496 0 0 1-.632.758l-.07-.057L5.5 5.767 2.346 8.922l-.068.057a.497.497 0 0 1-.633-.758l3.153-3.155-3.153-3.153a.496.496 0 0 1 0-.701z" _fill="#E25757"/>'
  }
})
